import { DocumentTypeEnum } from 'api-hooks/order/travel-document';
import { TravelDocumentSalesModel } from 'api-hooks/sale/travel-document';
import { Option } from 'baseui/select';
import { PreferenceFormSchema } from 'common/form-schema';
import * as Yup from 'yup';

export const DocumentSaleGuestDetailFormSchema = () =>
  Yup.object({
    //general
    id: Yup.string(),
    description: Yup.string().default(''),
    price: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),

    //apec, insurance, passport
    type: Yup.string(),

    //insurance
    startAt: Yup.date().nullable(),
    endAt: Yup.date().nullable(),
    days: Yup.number().transform((value) => (isNaN(value) ? undefined : value)),
    package: Yup.string(),
    company: Yup.string(),
    coverArea: Yup.string(),

    //visa
    appointmentAt: Yup.date().nullable(),
    biometric: Yup.boolean().default(false),
    visaDocumentId: Yup.string(),

    //additional data
    customId: Yup.string(),
    //addtitional data visa
    label: Yup.string().nullable(),
  });

export const DocumentSaleGuestTypeFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    guestId: Yup.string().default(''),
    preferences: Yup.array(PreferenceFormSchema()).default([]),
    details: Yup.array(DocumentSaleGuestDetailFormSchema()).default([]),

    //additional information
    customId: Yup.string(),
    guestName: Yup.string().default(''),
  });

export const DocumentSaleAddOnsFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    guestId: Yup.string().default(''),
    price: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    description: Yup.string().default(''),

    //additional information
    customId: Yup.string(),
    guestName: Yup.string().default(''),
  });

export const DocumentSalesFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    reminder: Yup.boolean().default(false),
    reminderDate: Yup.date().nullable().default(null),
    reminderDescription: Yup.string().nullable().default(''),
    documentReceiveDate: Yup.date().nullable().default(null),
    documentType: Yup.string().default(DocumentTypeEnum.visa),
    visaDocuments: Yup.array(PreferenceFormSchema()).default([]),
    documentSaleGuests: Yup.array(DocumentSaleGuestTypeFormSchema()).default(
      [],
    ),
    documentSaleAddOns: Yup.array(DocumentSaleAddOnsFormSchema()).default([]),

    //additional information
    customId: Yup.string(),
  });

export const FormSchema = () =>
  Yup.object({
    refId: Yup.string(),
    parentRefId: Yup.string(),
    transactionAt: Yup.date().default(new Date()),
    needApproval: Yup.boolean().default(false),
    code: Yup.string().default(''),
    description: Yup.string().default(''),
    adminId: Yup.string().default(''),
    operatorId: Yup.string().default(''),
    salesmanId: Yup.string().default(''),
    customerId: Yup.string().default(''),
    documentAdminId: Yup.string().default(''),
    customerBillingId: Yup.string().default(''),
    discount: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    otherCost: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    total: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    documentSales: Yup.array(DocumentSalesFormSchema()).default([]),

    //additional information
    tempTransactionAt: Yup.date().default(new Date()),
    phone: Yup.string().default(''),
    address: Yup.string().default(''),
    number: Yup.string().default(''),
    customerStatus: Yup.string().default(''),
    hasDueReceivable: Yup.boolean().default(false),
    remainingTransactionQuota: Yup.number().nullable().default(null),
    isExceedingQuota: Yup.boolean().default(false),
  });

export type DocumentSaleGuestDetailFormType = Yup.InferType<
  ReturnType<typeof DocumentSaleGuestDetailFormSchema>
>;

export type DocumentSaleGuestTypeFormType = Yup.InferType<
  ReturnType<typeof DocumentSaleGuestTypeFormSchema>
>;

export type DocumentSaleAddOnsFormType = Yup.InferType<
  ReturnType<typeof DocumentSaleAddOnsFormSchema>
>;

export type DocumentSalesFormType = Yup.InferType<
  ReturnType<typeof DocumentSalesFormSchema>
>;

export type DocumentSaleFormType = Yup.InferType<
  ReturnType<typeof FormSchema>
> & {
  customerBillingOptions: Option[];
  travelDocument?: TravelDocumentSalesModel;
};

export const ReminderFormSchema = () =>
  Yup.object({
    reminderDate: Yup.date().nullable().default(null),
    reminderDescription: Yup.string().nullable().default(''),
  });

export type ReminderFormType = Yup.InferType<
  ReturnType<typeof ReminderFormSchema>
>;
